import React, { useState, useEffect } from "react";
import { FaSearch } from "react-icons/fa";
import Header from "../Common/AdminHeader";
import axios from "axios";
import { Config } from "../../../API/config";
import toast from "react-hot-toast";
import { UserCheck } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { IoPerson } from "react-icons/io5";



interface User {
    _id: string;
    name: string;
    phone: string;
    profileImage: string;
    role: string;
}

interface Chat {
    _id: string;
    participants: string[];
    createdAt: string;
    updatedAt: string;
    __v: number;
    allParticipants: User[];
}
const EnterChat = () => {
    const navigate = useNavigate();
    const [chats, setChats] = useState<Chat[]>([]);
    const [loading, setLoading] = useState<boolean>(false);
    const [searchTerm, setSearchTerm] = useState("");
    const [page, setPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const fetchChats = async (pageNum: number) => {
        setLoading(true);
        try {
            const { data } = await axios.get(`${Config.getAllCHatsBYAdmin}?page=${pageNum}`, {
                withCredentials: true,
            });
            console.log(data.data);

            if (data.statusCode === 200) {
                setChats(data.data);
                setTotalPages(data.pagination?.totalPages || 1);
            }
        } catch (err) {
            toast.error("حدث خطأ أثناء جلب المحادثات");
            console.error("Error fetching chats:", err);
        } finally {
            setLoading(false);
        }
    }
    useEffect(() => {
        fetchChats(page);
    }, [page]);
    const handleButtonClick = async (chat: Chat) => {
        navigate("/adminviewchat", { state: { chat } });
    };
    const filteredChats = chats.filter((chat) => {
        const term = searchTerm.trim().toLowerCase();
        return (
            chat.allParticipants[0].name.toLowerCase().includes(term) ||
            chat.allParticipants[1].name.toLowerCase().includes(term) ||
            chat.allParticipants[0].phone.includes(term) ||
            chat.allParticipants[1].phone.includes(term)
        );
    });

    return (
        <div className="flex-1 overflow-auto relative z-10 bg-white">
            <Header title={"فتح المحادثات"} />

            <main className="max-w-7xl mx-auto py-6 px-4 lg:px-8">
                <div className="relative mb-4 flex justify-center">
                    <div className="relative w-full md:w-1/2">
                        <FaSearch className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-500" />
                        <input
                            type="text"
                            placeholder="ابحث عن محادثة أو رقم هاتف..."
                            className="w-full p-2 pl-10 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                            value={searchTerm}
                            onChange={(e) => setSearchTerm(e.target.value)}
                        />
                    </div>
                </div>

                <div className="bg-white border rounded-lg p-4 w-full max-w-3xl mx-auto mt-6">
                    <div className="flex justify-center items-center border-b pb-3">
                        <div className="flex items-center space-x-reverse space-x-2">
                            <h2 className="text-lg font-semibold text-gray-900">جميع المحادثات</h2>
                        </div>
                    </div>

                    {loading ? (
                        <p className="text-center text-gray-600 py-6">جارٍ التحميل...</p>
                    ) : (
                        <div className="mt-4 space-y-4">
                            {filteredChats.map((chat, index) => {
                                const trainer = chat.allParticipants[0];
                                const trainee = chat.allParticipants[1];

                                return (
                                    <div
                                        key={index}
                                        className="flex items-center justify-between p-4 mb-3 bg-gray-100 rounded-lg"
                                    >
                                        {/* Message Button on the left */}
                                        <button className="bg-green-500 text-white px-3 py-2 rounded-lg hover:bg-green-600 transition"
                                            onClick={() => handleButtonClick(chat)}>
                                            ابعت رسالة
                                        </button>


                                        <div className="flex flex-col items-end space-y-4">

                                            <div className="flex flex-row-reverse items-center space-x-reverse space-x-3">
                                                {trainer.profileImage ?
                                                    <img
                                                        src={trainer.profileImage}
                                                        alt={trainer.name}
                                                        className="w-10 h-10 rounded-full"
                                                    /> :
                                                    <div
                                                        className='w-10 h-10 rounded-full flex items-center justify-center overflow-hidden cursor-pointer bg-gradient-to-b from-neutral-400 to-neutral-300' // Moved gradient to container
                                                    >
                                                        <IoPerson size={25} color='#8e8e8' />
                                                    </div>}
                                                <div className="text-right">
                                                    <p className="text-gray-900 font-medium">{trainer.name}</p>
                                                    <p className="text-gray-500 text-sm">{trainer.role}</p>
                                                    <p className="text-gray-500 text-sm">{trainer.phone}</p> {/* Display phone */}
                                                </div>
                                            </div>

                                            {/* Trainee */}
                                            <div className="flex flex-row-reverse items-center space-x-reverse space-x-3">
                                                {trainee.profileImage ?
                                                    <img
                                                        src={trainee.profileImage}
                                                        alt={trainee.name}
                                                        className="w-10 h-10 rounded-full"
                                                    /> :
                                                    <div
                                                        className='w-10 h-10 rounded-full flex items-center justify-center overflow-hidden cursor-pointer bg-gradient-to-b from-neutral-400 to-neutral-300' // Moved gradient to container
                                                    >
                                                        <IoPerson size={25} color='#8e8e8' />
                                                    </div>}
                                                <div className="text-right">
                                                    <p className="text-gray-900 font-medium">{trainee.name}</p>
                                                    <p className="text-gray-500 text-sm">{trainee.role}</p>
                                                    <p className="text-gray-500 text-sm">{trainee.phone}</p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                );
                            })}
                        </div>
                    )}
                </div>
            </main>
        </div>
    );
};

export default EnterChat;